<div class="h-screen flex flex-col overflow-hidden bg-pageBg">
    <app-header class="shrink-0"></app-header>
    <div class="flex-1 flex flex-col min-h-0 overflow-hidden pt-4 pb-[60px] text-gray-800 antialiased">
        <div class="w-full mx-auto p-4 xl:p-8 flex-1 overflow-y-auto min-h-0 pb-12">

            <div style="background-color: aliceblue;"
                class="relative px-6 py-5 mb-6 bg-white border border-gray-200 shadow-sm rounded-xl overflow-hidden flex flex-col sm:flex-row items-center justify-between">
                <div
                    class="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brandPurple via-brandPurpleDark to-brandAccent">
                </div>
                <div class="flex items-center gap-4">
                    <img src="configure.svg" alt="Configure" class="h-8 opacity-40" />
                    <div>
                        <h1 class="text-xl f-700 text-brandPurple tracking-tight">System Configuration Settings</h1>
                        <p class="text-gray-500 mt-1 text-sm">Modify the System Configuration Settings below.</p>
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">

                <div class="bg-gray-50 border border-gray-200 rounded-xl p-6 shadow-sm h-fit">
                    <div class="flex items-center gap-2 mb-4 text-brandPurple font-bold">
                        <span class="text-xl">ℹ️</span>
                        <span class="text-sm uppercase tracking-wider">Information</span>
                    </div>
                    <div class="text-sm text-gray-600 font-medium space-y-3">
                        <p>
                            If Allow Collection Attribute is <strong class="text-gray-800">YES</strong> then, Collection
                            Level Attributes are supported and items can belong to only one Collection.
                        </p>
                        <p>
                            Otherwise, Collection Level Attributes are <strong class="text-gray-800">NOT</strong>
                            Supported.
                        </p>
                        <p>
                            An item can belong to multiple Collections; that is, Collection becomes a multi-select field
                            if
                            the flag is NO.
                        </p>
                    </div>
                </div>

                <div class="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden flex flex-col h-fit">

                    <div *ngIf="isLoading" class="p-8 flex justify-center items-center text-gray-400 text-sm italic">
                        Loading configuration...
                    </div>

                    <div *ngIf="!isLoading" class="overflow-x-auto">
                        <table class="min-w-full text-sm text-left table-fixed">
                            <thead class="bg-gray-50 border-b border-gray-200 text-gray-700">
                                <tr>
                                    <th class="px-6 py-3 f-700 uppercase">Feature Description</th>
                                    <th class="px-6 py-3 f-700 uppercase text-center w-32">Yes / No</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover:bg-pageBg transition-colors border-b border-gray-100">
                                    <td class="px-6 py-4 font-medium text-gray-800">{{
                                        allowCollectionDetails.description }}
                                    </td>
                                    <td class="px-6 py-4 text-center">
                                        <input type="checkbox" id="allow_collection_attributes"
                                            class="rounded border-gray-300 text-brandAccent focus:ring-brandAccent w-5 h-5 cursor-pointer transition"
                                            [ngModel]="allowCollectionDetails.yes_or_no == 1"
                                            (ngModelChange)="allowCollectionDetails.yes_or_no = $event ? 1 : 0; resetMessages()">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div
                        class="p-4 bg-gray-50 border-t border-gray-200 flex flex-col sm:flex-row gap-4 justify-between items-center">

                        <div class="flex-1 w-full">
                            <div *ngIf="message && !errorMessage"
                                class="bg-green-50 border-l-4 border-green-500 p-3 rounded-md shadow-sm flex justify-between items-center">
                                <span class="text-green-700 text-sm font-bold">{{ message }}</span>
                                <button type="button"
                                    class="text-green-700 hover:text-green-900 focus:outline-none font-bold"
                                    (click)="message = null">&times;</button>
                            </div>
                            <div *ngIf="errorMessage && !message"
                                class="bg-red-50 border-l-4 border-red-500 p-3 rounded-md shadow-sm flex justify-between items-center">
                                <span class="text-red-700 text-sm font-bold">{{ errorMessage }}</span>
                                <button type="button"
                                    class="text-red-700 hover:text-red-900 focus:outline-none font-bold"
                                    (click)="errorMessage = null">&times;</button>
                            </div>
                        </div>

                        <button
                            class="bg-brandAccent hover:bg-brandPurple text-white px-5 py-2 rounded-md text-sm font-bold shadow-sm transition disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                            (click)="checkAllowCollectionDependency(allowCollectionDetails)"
                            [disabled]="isUpdating || showDependency">
                            <span *ngIf="!isUpdating || showDependency">Update</span>
                            <span *ngIf="isUpdating && !showDependency">Updating ...</span>
                        </button>
                    </div>
                </div>

            </div>

            <div *ngIf="showDependency"
                class="bg-white border-l-4 border-brandAccent rounded-xl shadow-sm p-6 mb-6 flex flex-col md:flex-row gap-6 items-start md:items-center">

                <div class="flex items-center justify-center w-12 h-12 rounded-full bg-red-50 text-red-500 shrink-0">
                    <span class="text-2xl font-bold">!</span>
                </div>

                <div class="flex-1 text-sm text-gray-700">
                    <h3 class="text-base f-700 text-gray-800 mb-1">Note</h3>
                    <p class="leading-relaxed">
                        Updating the <strong>'Allow Collection Attributes'</strong> feature to
                        <strong *ngIf="allowCollectionDetails.yes_or_no == 1" class="text-brandAccent">True</strong>
                        <strong *ngIf="allowCollectionDetails.yes_or_no != 1" class="text-brandAccent">False</strong>

                        <span *ngIf="allowCollectionDetails.yes_or_no == 1">
                            removes the <span
                                class="bg-brandAccent/10 text-brandPurple px-1.5 py-0.5 rounded font-bold">Item
                                Collection</span> referred in the item maintenance in Prime.
                        </span>
                        <span *ngIf="allowCollectionDetails.yes_or_no != 1">
                            affects the <span
                                class="bg-brandAccent/10 text-brandPurple px-1.5 py-0.5 rounded font-bold">Item Types
                                'Allow
                                Collection'</span> flag and will remove the
                            <span class="bg-brandAccent/10 text-brandPurple px-1.5 py-0.5 rounded font-bold">collection
                                level UDD's</span> and their related
                            <span class="bg-brandAccent/10 text-brandPurple px-1.5 py-0.5 rounded font-bold">bridge
                                values</span>.
                        </span>
                    </p>
                </div>



                <div class="flex gap-3 shrink-0 mt-4 md:mt-0">
                    <button
                        class="px-4 py-2 border border-gray-300 bg-white text-gray-700 rounded-md shadow-sm text-sm font-bold hover:bg-gray-50 transition"
                        (click)="showDependency = false; allowCollectionDetails.yes_or_no = allowCollectionDetails.yes_or_no == 1 ? 0 : 1">
                        Cancel
                    </button>
                    <button
                        class="px-4 py-2 bg-brandAccent hover:bg-brandPurple text-white rounded-md shadow-sm text-sm font-bold transition disabled:opacity-50 disabled:cursor-not-allowed"
                        [disabled]="isUpdating" (click)="updateSystemConfigurationSettings(allowCollectionDetails)">
                        <span *ngIf="!isUpdating">Proceed</span>
                        <span *ngIf="isUpdating">Processing ...</span>
                    </button>
                </div>
            </div>

        </div>
        <footer class="login-footer">
            <span *ngIf="copyrightDetails">
                &copy; {{ copyrightDetails.from_year }} - {{ copyrightDetails.to_year }},
                Retail Calculus or its affiliates. All rights reserved.
            </span>
            <span *ngIf="!copyrightDetails">
                &copy; 2016 - 2026, Retail Calculus or its affiliates. All rights reserved.
            </span>

            <div class="footer-links">
                <a href="javascript:void(0)">Privacy Policy</a>
                <a href="javascript:void(0)">Terms of Use</a>
                <span class="version" *ngIf="copyrightDetails?.app_version">
                    Version {{ copyrightDetails.app_version }}
                </span>
            </div>
        </footer>
    </div>
</div>